import script from "./AnnouncementIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnouncementIndex.vue?vue&type=script&setup=true&lang=js"

import "./AnnouncementIndex.vue?vue&type=style&index=0&id=634150e8&lang=css"
import "./AnnouncementIndex.vue?vue&type=style&index=1&id=634150e8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-634150e8"]])

export default __exports__